import { getInclusionOptions } from '../logicHelpers'

const rightmessageSource = () => {
  const questionStore = useQuestionStore()
  const { questions } = storeToRefs(questionStore)

  return {
    types: [
      { label: 'Current Widget', value: 'widget' },
      { label: 'Question Engagement', value: 'question' }
    ],
    inputs: [
      {
        $formkit: 'select',
        key: 'widget-operator-select',
        id: 'operator',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'widget'
      },
      {
        $formkit: 'autocomplete',
        key: 'widget-value',
        name: 'value',
        multiple: true,
        options: () => {
          const route = useRoute()
          const widgetStore = useWidgetStore()
          const widgets = widgetStore.getWidgetsForOfferFunnel(
            route.params.offerFunnelId
          )

          return widgets.map((widget) => {
            return {
              label: widget.name,
              value: widget.id
            }
          })
        },
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'widget'
      },
      {
        $formkit: 'select',
        key: 'question-operator-select',
        id: 'operator',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'question'
      },
      {
        $formkit: 'multiselect',
        key: 'question-value-select',
        name: 'questionId',
        multiple: true,
        'open-on-focus': true,
        'clear-search-on-open': true,
        options: questions.value.map((question) => ({
          label: stripHtml(question.text),
          value: question.id
        })),
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'rightmessage' &&
          condition.$type === 'question' &&
          (condition.operator || '').includes('include')
      },
      {
        $formkit: 'select',
        key: 'question-scope-select',
        id: 'scope',
        name: 'scope',
        options: [
          {
            label: 'this page view',
            value: 'pageview'
          }
          // {
          //   label: 'in the last',
          //   value: 'timeframe'
          // }
        ],
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'rightmessage' && condition.$type === 'question'
      }
    ]
  }
}

export default rightmessageSource
